import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ParticipantCardComponent } from './components/participant-card/participant-card.component';
import { SessionHandoffPageComponent } from './components/session-handoff-page/session-handoff-page.component';
import { WelcomePageV2Component } from './containers/welcome-page-v2/welcome-page-v2.component';
import { SessionHandoffEffects } from './store/effects/session-handoff.effects';
import { sessionHandoffReducer } from './store/reducers/session-handoff.reducer';
import { SharedModule } from '../shared';

@NgModule({
  declarations: [
    SessionHandoffPageComponent,
    ParticipantCardComponent,
    WelcomePageV2Component,
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('sessionHandoff', sessionHandoffReducer),
    EffectsModule.forFeature([SessionHandoffEffects]),
  ],
  exports: [ WelcomePageV2Component ],
})
export class SessionHandoffModule {}
